module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate1_m_en.afd7c702b75d7c50f05fb9fd1d8b2e42.png";